export const organizationName = 'NYU College of Dentistry';
export const maximumUsersUpload = 50;
export const userAccessTableTitle = 'List of members';
export const tableWaitLoadTime = 10000; // 10s
export const projectName = 'inbde';
